export default function commentParseResource({ data }) {
  return {
    reference: data?.reference,
    title: data?.title,
    customerContent: data?.content,
    composition: data?.composition,
    averageRate: Number(data?.averageRate),
    fairnessRate: Number(data?.fairnessRate),
    greetingRate: Number(data?.greetingRate),
    qualityRate: Number(data?.qualityRate),
    cosinessRate: Number(data?.cosinessRate),
    customerName: data?.customerName,
    ownerContent: data?.answerOwner,
    agentContent: data?.answerAgent,
    ownerName: data?.ownerName,
    answeredAt: data?.answered,
    publishedAt: data?.published,
  };
}
